import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  Wrapper,
  Title,
  Text,
  Buttons,
  AlternativeText,
} from "./styles/modal-thank-you";
import { toggleFinishJobPostModal } from "../../actions/dashboardActions";
import Button from "../shared/button/Button";
import trackEvent from "../shared/ga/trackEvent";
import { connect } from "react-redux";

class ModalThankYou extends Component {
  componentDidMount() {
    trackEvent("Form Fill", "Post A Job", "Full");
  }

  handleLink() {
    const { scheduleCallLink } = this.props;
    window.location.href = scheduleCallLink;
  }

  render() {
    const { purple, jobId, toggleFinishJobPostModal } = this.props;
    return (
      <Wrapper purple={purple}>
        <Title className="animated fadeIn delayOne">
          We&#39;ve got your job!
        </Title>
        <Text className="animated delayTwo fadeInDown">
          To maintain high standards on our marketplace and ensure only
          qualified jobs from motivated employers are posted to our network of
          recruitment agencies, a member of our customer team will be in touch
          shortly to qualify your job and turn your job description into a brief
          to support recruiter&#39;s candidate search (and improve the chances
          of a successful hire, fast!). It only takes five minutes and once
          you&#39;re happy, we&#39;ll get your job live on the marketplace and a
          notification will be sent to relevant recruiters. Sit tight...
        </Text>
        <Buttons className="animated delayThree fadeInUp">
          <Button
            primary
            buttonName="Schedule Call"
            noFocus
            onClickAction={() => this.handleLink()}
          />
          <Button
            buttonName="Close"
            noFocus
            onClickAction={() => {
              toggleFinishJobPostModal(jobId);
            }}
          />
        </Buttons>
        <AlternativeText className="animated delayFour fadeInUp">
          Or call: 0161 300 7235
        </AlternativeText>
      </Wrapper>
    );
  }
}

ModalThankYou.propTypes = {
  toggleFinishJobPostModal: PropTypes.func.isRequired,
  purple: PropTypes.bool.isRequired,
  scheduleCallLink: PropTypes.string.isRequired,
  jobId: PropTypes.string,
};

export default connect(null, { toggleFinishJobPostModal })(ModalThankYou);
